import React, { Component } from 'react';

export default function sort(Table) {
    return class SortTable extends Component {
        constructor(props) {
            super(props);
            let flatColumns = [];
            this.toFlatColumn(props.columns, -1, flatColumns);
            this.state = {
                //获取列信息
                iconColumns: props.columns,
                //获取列表数据
                data: props.data,
                //考虑多级表头情况,扁平化列头
                flatColumns: flatColumns,
            }
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            // if (nextProps.columns != this.props.columns) {
            //     this.setState({
            //         iconColumns: nextProps.columns,
            //     })
            // }
            // if (nextProps.data !== this.props.data) {
            //     this.setState({
            //         data: nextProps.data,
            //         // orderNum: nextProps.orderNum,
            //     })
            // }
            let flatColumns = [];
            this.toFlatColumn(nextProps.columns, -1, flatColumns);
            this.setState({
                data: nextProps.data,
                iconColumns: nextProps.columns,
                flatColumns: flatColumns,
            })
        }
        /**
         * 列信息扁平化处理
        * @param {*} columns 原始列数据
        * @param {*} flatColumns 扁平列数据
        */
        toFlatColumn(columns, parentIndex = -1, flatColumns = []) {
            let children = [];
            columns.forEach((item, index)=> {
                item.parentIndex = parentIndex;
                children = item.children;
                flatColumns.push(item);
                if (children) {
                    this.toFlatColumn(children, index, flatColumns);
                }
            });
        }
        /**
        *  点击排序icon,更新数据
        * @param {*} thisColumn 点击的那一列头信息
        * @param {*} order 排序类型 -ascend/descend
        */
        onTitleSortClick = (thisColumn, order) => {
            let { flatColumns } = this.state;
            let { sort } = this.props
            let { data } = this.state;
            thisColumn.order = order;
            let seleObj;
            let sortCol; 
           
            // 多列
            if (sort && sort.mode == 'multiple') {
                seleObj = flatColumns.find(item => item.key == thisColumn.key);
                seleObj.order = order;
                //TODO 思考用户想改变排序优先级情况
                // if (order === "") {
                //     this.changeOrderNum(thisColumn);
                // }
                if (!seleObj.orderNum && (order == "ascend" || order == "descend")) {
                    thisColumn.orderNum = seleObj.orderNum = this.getOrderNum();
                }
                // 获取排序字段，例如对象{[order: "ascend",field: "contact",orderNum: 1]}
                sortCol = this.getOrderCols(flatColumns);
                // 获取排序对象{[每一行参与排序的数据]}
                data = this.multiSort(flatColumns);
                typeof sort.sortFun === "function" && sort.sortFun(sortCol, data);
            } else {//单列，为默认值
                // 获取排序字段，例如对象{[order: "ascend",field: "contact"]}
                flatColumns.forEach(item => {
                    //1单列时，仅当前点击的列头显示图标
                    if (item.key == thisColumn.key) {
                        item.sortFlag = true;
                    } else {
                        item.sortFlag = false;
                    }
                });

                sortCol = [{ order: order, field: thisColumn.dataIndex }]
                // sortParam = [{ order: order, field: thisColumn.dataIndex }]
                if (order === "ascend") {
                    data = data.sort(function (a, b) {
                        return thisColumn.sorter(a, b);
                    });
                } else if (order === "descend") {
                    data = data.sort(function (a, b) {
                        return thisColumn.sorter(b, a);
                    });
                }
                typeof sort.sortFun === "function" && sort.sortFun(sortCol, data);
            }
            console.log(this.state.iconColumns)
            this.setState({ data, flatColumns})
        }
        /**
         * 当有的列不排序时，将该列的orderNum置为‘’，并动态的修改其他列的orderNum。
         * @param {*} column 当前的排序的列
         */
        changeOrderNum = column => {
            let { flatColumns } = this.state;
            flatColumns.forEach(col => {
                if (col.orderNum > column.orderNum) {
                    col.orderNum--;
                }
                if (column.key == col.key) {
                    col.orderNum = "";
                }
            });
            this.setState({ flatColumns });
        };
        /**
         * 多列排序的优先级
         * @returns 多列排序的第几列
         */
        getOrderNum = () => {
            let orderNum = 0;
            this.state.flatColumns.forEach(item => {
                if (item.order == "ascend" || item.order == "descend") {
                    orderNum++;
                }
            });
            return orderNum ? orderNum : 1;
        };
       /**
        * 获取排序字段
        * @param {*} columns 所有列头信息
        * @returns 
        */
        getOrderCols = columns => {
            let orderCols = [];
            columns.forEach(item => {
                if (item.order == "ascend" || item.order == "descend") {
                    orderCols.push({
                        order: item.order,
                        field: item.dataIndex,
                        orderNum: item.orderNum,
                    });
                }
            });
            return orderCols;
        };
        /**
         * 多列排序 先排order为1的，其他的基于已排序的数据排列
         * @param {*} columns 所有列头信息
         * @returns 排序后的数据
         */
        multiSort = columns => {
            let { data } = this.state;
            const self = this;
            let orderCols = {}, orderColslen = 0;
            columns.forEach(item => {
                if (item.orderNum) {
                    orderColslen++;
                    orderCols[item.orderNum] = item;
                }
            });
            if (orderColslen > 0) {
                data = data.sort(function (a, b) {
                    return self.sortBy(a, b, orderCols, orderColslen, 1);
                });
            }
            return data;
        };

        /**
         * 
         * @param {*} pre 前一条数据
         * @param {*} after 后一条数据
         * @param {*} orderCols 参与排序的列
         * @param {*} orderColslen 参与排序列数
         * @param {*} currentIndex 当前排序列下标
         * @returns 排序后的数据
         */
        sortBy = (pre, after, orderCols, orderColslen, currentIndex) => {
            // 获取当前排序列的值
            const currentCol = orderCols[currentIndex];
            let preKey = (pre.values && pre.values[currentCol.key].value) || (pre[currentCol.key]&&pre[currentCol.key].value) || pre[currentCol.key];
            let afterKey = (after.values && after.values[currentCol.key].value) || (after[currentCol.key]&&after[currentCol.key].value) || after[currentCol.key];

            let colSortFun = currentCol.sorter;
            if (typeof colSortFun !== 'function') {
                colSortFun = () => preKey - afterKey;
            }
            // 若当前列值相同，则比较下一个优先级列的值
            if (preKey == afterKey && currentIndex + 1 <= orderColslen) {
                return this.sortBy(pre, after, orderCols, orderColslen, currentIndex + 1);
            }
            if (currentCol.order == "ascend") {
                return colSortFun(pre, after);
            } else {
                return -colSortFun(pre, after);
            }
        };

        render() {
            let { rowKey, ...others } = this.props;
            let { data, iconColumns, flatColumns } = this.state;
            return (
                <Table
                    {...others}
                    columns={iconColumns}
                    data={data}
                    rowKey={rowKey}
                    sortCallback={this.onTitleSortClick}
                />
            )
        }
    }
}

